<script lang="jsx">
import ZmButton from '@/components/zoom-ui-plus/button/index.vue';
import { computedPbxPlans } from '@/common/service/computers/plans/pbx';
import mixin from '@/plans/mx/shopping-cart';
import { routePathMap } from '@/router/constant';
import { getDefaultPayApmInfo } from '@/store/modules/payment';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import AltProratedPlanMultiple from '@/views/config/shopping-cart/prorated/multiple.vue';
import { mapGetters } from 'vuex';
import { planTypes } from '@/common/constants';
import { isZPALinkInZoomPhoneContext } from '@/flows/services/utils';

export default {
  mixins: [mixin],
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
    AltProratedPlanMultiple,
  },
  computed: {
    ...mapGetters(['isZPAContext']),
    selectedPbxPlans() {
      return computedPbxPlans(this.getSelectedPlans);
    },
    zpaPlans() {
      return this.selectedPbxPlans.filter(item => item.type === planTypes.ZOOM_PHONE$ZPA);
    },
    isShowRmvBtn() {
      return !!this.$context.is.checkoutPage && !isZPALinkInZoomPhoneContext();
    },
  },
  methods: {
    mx_edit_addon(plan) {
      if (!this.$context.is.checkoutPage || this.$context.is.switchCurrency) return;
      return (
        <ZmButton
          type="text"
          aria-label={`${this.$t('billing.common.edit')} ${this.$t(plan?.planNameKey)}`}
          onClick={() => {
            this.checkProMonthlyAndYearlyPriceChange();
            this.$router.push({
              path: routePathMap.config,
            });
            if (this.apmInfo.isApm) {
              this.$nextTick(() => {
                this.setApmInfo(getDefaultPayApmInfo());
              });
            }
            this.$tracking.orderSummary(
              `edit ${this.__pkg.components?.addon ? 'add-on product' : 'product'} - ${this.$t(plan.planNameKey)}`,
            );
          }}
        >
          {this.$t('billing.common.edit')}
        </ZmButton>
      );
    },
    $renderPrice() {
      if (!isZPALinkInZoomPhoneContext()) return;
      return (
        <div class="opc-cart-item">
          {this.mx_main_title(this.$t('billing.pbx.plan_name.ZPA'), undefined, 'ZMV')}
          <div class="pbx-cart-part">
            {this.zpaPlans.map((item) => (
              <div class="pbx-cart-part__item" key={item.plan_code}>
                <AltProratedPlanMultiple code={item.plan_code}>
                  {this.mx_discount(item.plan_code)}
                  {this.mx_cycle(item.billing_cycle)}
                  <AltProratedPlanUser code={item.plan_code}>
                    {this.mx_new_license(item, item.cartInfo.selected_number)}
                  </AltProratedPlanUser>
                  <AltProratedPlanPeriod code={item.plan_code} />
                  {this.mx_edit_addon(item)}
                  {this.isShowRmvBtn && this.mx_remove(item)}
                </AltProratedPlanMultiple>
              </div>
            ))}
          </div>
        </div>
      );
    },
  },
};
</script>
<style lang="scss">
.pbx-cart-part {
  margin-bottom: 10px;
  &__item{
    &:not(:last-child){
      margin-bottom: 10px;
    }
  }
}
</style>
